import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { Button } from 'antd';


class PageNotFound extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    title: PropTypes.any,
    message: PropTypes.any,
  };

  static defaultProps = {
    title: 'Page Not Found',  // 'You must be logged in to view this page!',
    message: null,
  };

  constructor(props) {
    super(props);

    this.onGoBackClicked = this.onGoBackClicked.bind(this);
  }

  onGoBackClicked() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="page-not-found">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header no-border">
              <h5 className="modal-title">{this.props.title}</h5>
            </div>
            <div className="modal-body center">
              {this.props.message}
              <div className="d-flex justify-content-space-between">
                <Button className="mx-3" type="primary" size="large" onClick={this.onGoBackClicked}>Go Back</Button>
                <NavLink className="mx-3" to="/">
                  <Button type="primary" size="large">Go Home</Button>
                </NavLink>
              </div>
            </div>
            <div className="modal-footer">
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default withRouter(PageNotFound);


